import { graphql } from "gql.tada";

const RestaurantCuisineFragment = graphql(`
  fragment RestaurantCuisineFragment on RestaurantCuisine {
    id
    title
  }
`);

export default RestaurantCuisineFragment;
